/**
 * 인덱스를 A, B, C... 형태의 알파벳으로 변환하고 반대로 변환하는 유틸리티
 */
export const letterConverter = {
  /**
   * 인덱스를 알파벳으로 변환 (0 -> 'A', 1 -> 'B', ...)
   * @param index 변환할 인덱스 (0부터 시작)
   * @returns 변환된 알파벳
   */
  indexToAlphabet: (index: number): string => {
    if (index < 0) {
      throw new Error('Index must be non-negative');
    }
    return String.fromCharCode(index + 'A'.charCodeAt(0));
  },

  /**
   * 알파벳을 인덱스로 변환 ('A' -> 0, 'B' -> 1, ...)
   * @param char 변환할 알파벳 (A-Z)
   * @returns 변환된 인덱스
   */
  alphabetToIndex: (char: string): number => {
    if (!char || char.length !== 1) {
      throw new Error('Input must be a single character');
    }
    const upperChar = char.toUpperCase();
    if (upperChar < 'A' || upperChar > 'Z') {
      throw new Error('Character must be between A-Z');
    }
    return upperChar.charCodeAt(0) - 'A'.charCodeAt(0);
  },
};
